module.exports = __webpack_public_path__ + "img/re-en_ID-img2.2c3264f4.png";